/* ============================================================================
   SEVEN REASONS SHORT  ·  section JS
   IIFE-scoped. State at window.__sevenReasonsShort to avoid cross-section collision.
   ============================================================================ */
(function () {
  'use strict';

  function init() {
    var sections = document.querySelectorAll('.shopify-section.section-seven-reasons-short');
    if (!sections.length) return;

    sections.forEach(function (section) {
      if (section.dataset.srInit === '1') return;
      section.dataset.srInit = '1';

      initCountdown(section);
      initReviewsRail(section);
      initFAQ(section);
      initStickyBar(section);
      initProgressBar(section);
    });
  }

  // ── Countdown timer ────────────────────────────────────────────────────
  function initCountdown(section) {
    var timer = section.querySelector('.vt-announce__timer');
    if (!timer) return;
    var h = parseInt(timer.dataset.countdownHours, 10);
    var m = parseInt(timer.dataset.countdownMinutes, 10);
    var s = parseInt(timer.dataset.countdownSeconds, 10);
    if (isNaN(h)) h = 12;
    if (isNaN(m)) m = 0;
    if (isNaN(s)) s = 0;

    var hEl = timer.querySelector('.vt-cd-h');
    var mEl = timer.querySelector('.vt-cd-m');
    var sEl = timer.querySelector('.vt-cd-s');
    if (!hEl || !mEl || !sEl) return;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function render() {
      hEl.textContent = pad(h);
      mEl.textContent = pad(m);
      sEl.textContent = pad(s);
    }
    function tick() {
      s -= 1;
      if (s < 0) { s = 59; m -= 1; }
      if (m < 0) { m = 59; h -= 1; }
      if (h < 0) {
        h = parseInt(timer.dataset.countdownHours, 10) || 12;
        m = 0;
        s = 0;
      }
      render();
    }
    render();
    setInterval(tick, 1000);
  }

  // ── Reviews carousel (scroll-snap rail) ────────────────────────────────
  function initReviewsRail(section) {
    var rail = section.querySelector('[data-rail]');
    if (!rail) return;
    var btns = section.querySelectorAll('.vt-reviews__btn');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = btn.getAttribute('data-direction') === 'next' ? 1 : -1;
        rail.scrollBy({
          left: dir * (rail.clientWidth * 0.85),
          behavior: 'smooth'
        });
      });
    });
  }

  // ── FAQ — exclusive open (one at a time) ───────────────────────────────
  function initFAQ(section) {
    var items = section.querySelectorAll('.vt-faq__item');
    if (!items.length) return;
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (item.open) {
          items.forEach(function (other) {
            if (other !== item && other.open) other.open = false;
          });
        }
      });
    });
  }

  // ── Sticky buy bar — show after scroll threshold ───────────────────────
  function initStickyBar(section) {
    var sticky = section.querySelector('[data-sticky]');
    if (!sticky) return;

    // In design mode, the CSS rule keeps it visible — skip scroll logic.
    if (window.Shopify && window.Shopify.designMode) {
      sticky.classList.add('is-visible');
      return;
    }

    var threshold = parseInt(sticky.dataset.showAfter, 10);
    if (isNaN(threshold)) threshold = 600;

    var ticking = false;
    function update() {
      var visible = (window.scrollY || window.pageYOffset) > threshold;
      sticky.classList.toggle('is-visible', visible);
      ticking = false;
    }
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  // ── Scroll progress bar ────────────────────────────────────────────────
  function initProgressBar(section) {
    var fill = section.querySelector('[data-progress-fill]');
    if (!fill) return;

    var ticking = false;
    function update() {
      var doc = document.documentElement;
      var body = document.body;
      var scrollTop = window.scrollY || window.pageYOffset || doc.scrollTop || body.scrollTop || 0;
      var docHeight = Math.max(
        body.scrollHeight, doc.scrollHeight,
        body.offsetHeight, doc.offsetHeight,
        body.clientHeight, doc.clientHeight
      );
      var viewportHeight = window.innerHeight || doc.clientHeight;
      var scrollable = Math.max(docHeight - viewportHeight, 1);
      var pct = Math.min(Math.max((scrollTop / scrollable) * 100, 0), 100);
      fill.style.width = pct + '%';
      ticking = false;
    }
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when Shopify Theme Editor re-renders a section.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.classList.contains('section-seven-reasons-short')) {
      init();
    }
  });

  // Expose a tiny namespace for debugging / external triggers.
  window.__sevenReasonsShort = window.__sevenReasonsShort || {
    version: '1.0.0',
    reinit: init
  };
})();